"use client";

import { useEffect, useRef } from "react";

export default function AboutHeader() {
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const els = ref?.current?.querySelectorAll(".reveal");
        if (!els) return;
        const observer = new IntersectionObserver(
            (entries) =>
                entries.forEach((e) => {
                    if (e.isIntersecting) {
                        e.target.classList.add("visible");
                        observer.unobserve(e.target);
                    }
                }),
            { threshold: 0.1 }
        );
        els?.forEach((el) => observer?.observe(el));
        return () => observer?.disconnect();
    }, []);

    return (
        <section
            ref={ref}
            className="section-navy-mid"
            style={{ paddingTop: "0px", paddingBottom: "80px" }}
        >
            <div
                className="px-6 lg:px-12"
                style={{ maxWidth: "1280px", margin: "0 auto" }}
            >
                <div
                    className="px-6 lg:px-12 text-center"
                    style={{ maxWidth: "1280px", margin: "0 auto" }}
                >
                    <div
                        className="flex items-center justify-center gap-3 mb-8 reveal"
                    >
                        <span className="type-caption" style={{ color: "var(--color-red)" }}>AUDIT & DOCUMENTATION</span>
                    </div>
                    <h1
                        className="reveal reveal-delay-1"
                        style={{
                            fontFamily: "var(--font-serif)",
                            fontSize: "clamp(1.75rem, 3vw, 2.5rem)",
                            fontWeight: 400,
                            color: "var(--color-white)",
                            lineHeight: 1.15,
                            letterSpacing: "-0.015em",
                            margin: "0 auto",
                        }}
                    >
                            Full Audit Trail
                    </h1>
                    <p
                        className="type-body reveal reveal-delay-2"
                        style={{
                            fontFamily: "var(--font-sans)",
                            fontSize: "1.0625rem",
                            color: "rgba(255,255,255,0.55)",
                            lineHeight: "1.7",
                            marginTop: "20px",
                            margin: "20px auto 0",
                        }}
                    >
                            We maintain records and support reasonable third-party audit procedures by agreement:
                    </p>
                </div>

                <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 reveal reveal-delay-2 mt-10">
                    {[
                        "Assays",
                        "Weights",
                        "Invoices",
                        "Shipping docs",
                        "Benchmark refs",
                        "Compliance records",
                    ].map((item) => (
                        <div
                            key={item}
                            className="card p-4 text-center"
                            style={{
                                fontFamily: "var(--font-sans)",
                                fontSize: "0.9375rem",
                                fontWeight: 500,
                                color: "var(--color-white)",
                            }}
                        >
                            {item}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}